import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../Api/api';

function RegisterForm() {

    const [name, setName] = useState('');          
    const [email, setEmail] = useState('');         
    const [password, setPassword] = useState('');    
    const [confirmPassword, setConfirmPassword] = useState(''); 
    const [phone, setPhone] = useState('');
    const navigate = useNavigate(); // For navigation after signup
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        //check if the password and confirm password are the same
        if (password.length < 6) {
            setError("Password must be at least 6 characters.");
            return;
          }
      
          if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
          }

        try {
            // 1. Check if user already exists, create new user to db
            const newUser = { name, email, password, phone };
            
            const response = await api.post('/auth/register', newUser);
            const data = response.data;
            const user = data.user;
            const token = data.token;

            if (response.status === 201 || response.status === 200) {
                localStorage.setItem('currentUser', JSON.stringify(user));
                localStorage.setItem('token', token);
              setSuccess("Account created! Redirecting...");
              navigate("/dashboard");
            } else {
              setError("Registration failed.");
            }
          } catch (err) {
            console.error(err);
            setError(err.response?.data?.message || "Something went wrong. Try again.");
          }
        
    };

    
    return (
        <div className="container mt-5 d-flex justify-content-center">
            <div className="card shadow p-4" style={{ maxWidth: '400px', width: '100%' }}>
                <h2 className="mb-4 text-center">Create Account</h2>
                {/* Show error message if there is one */}
                {error && <div className="alert alert-danger" role="alert">{error}</div>}
                {/* Show success message if there is one */}
                {success && <div className="alert alert-success" role="alert">{success}</div>}
                {/* The signup form */}
                <form onSubmit={handleSubmit}>
                    {/* Name input */}
                    <div className="mb-3">
                        <label className="form-label">Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter your name"
                        />
                    </div>

                    {/* Email input */}
                    <div className="mb-3">
                        <label className="form-label">Email:</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                        />
                    </div>
                    {/* phone input */}
                    <div className="mb-3">
                        <label className="form-label">Phone:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="Enter your phone number"
                        />
                    </div>

                    {/* Password input */}
                    <div className="mb-3">
                        <label className="form-label">Password:</label>
                        <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Create a password"
                        />
                        <div className="form-text">Password must be at least 6 characters long</div>
                    </div>

                    {/* Confirm Password input */}
                    <div className="mb-4">
                        <label className="form-label">Confirm Password:</label>
                        <input
                            type="password"
                            className="form-control"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Enter password again"
                        />
                    </div>

                    {/* Submit button */}
                    <div className="d-flex justify-content-center">
                        <button type="submit" className="btn btn-primary register-btn">
                            Create Account
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default RegisterForm;